<template lang="pug" src="./v-alert.pug"></template>

<style rel="stylesheet/scss" lang="scss" scoped>
    .errors {
        position: fixed;
        bottom: 50px;
        right: 50px;
        z-index: 9999;
    }
    .v-alert {
        min-width: 280px;
        text-align: center;
        margin-bottom: 10px;
    }
    .slide-fade-enter-active {
        transition: all .6s ease;
    }
    .slide-fade-leave-active {
        transition: all .4s ease-in-out;
    }
    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(50px);
        opacity: 0;
    }
    .slide-fade-leave-to {
        transform: translateY(-100px);
    }

    ::v-deep .v-alert.success{
        border-radius: 4px;
    }

    ::v-deep .v-alert.error{
        border-radius: 4px;
    }

    @media only screen and (max-width: 500px) {
        .errors {
            left: 10px;
            right: 10px;
            bottom: 0;
        }
    }
</style>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        iconNames: {
            error: 'error',
            info: 'info',
            success: 'done'
        }
    }),
    computed: {
        ...mapState({
            items: state => state.alert.messages
        })
    },
    methods: {
        getIconName(type) {
            return this.iconNames[type];
        }
    }
};
</script>
